import Payment from 'payment';

// loose enough for US ( 12345 / 12345-6789 ) and Canadian ( A1A 1A1 ) codes
const ZIP_PATTERN = /^[a-z0-9][a-z0-9 -]{2,9}$/i;

export const validateCC = ({ payment_profile_id, number, expiry, cvc, zip }) => {
  const type = Payment.fns.cardType( number );

  return new Promise( ( resolve, reject ) => {
    // if payment profile id is preset, return the profile id as valid
    if ( payment_profile_id ) {
      return resolve({ payment_profile_id })
    }
    // if there is no card number or payment profile, then nothing was provided.
    if ( !number && !expiry && !cvc ) {
      return reject( new Error('Please Select a Payment Method') );
    }
    // validate the card number
    if ( !Payment.fns.validateCardNumber( number ) ) {
      return reject( new Error('Invalid Credit Card Number') );
    } else if ( !Payment.fns.validateCardExpiry( expiry ) ) {
      return reject( new Error('Invalid Exparation Date') );
    } else if ( !Payment.fns.validateCardCVC( cvc, type ) ) {
      return reject( new Error('Invalid CVC (Code)') );
    // the card's billing zip is what the bank checks ( AVS ), so it is required
    } else if ( !ZIP_PATTERN.test( ( zip || '' ).trim() ) ) {
      return reject( new Error("Invalid Billing Zip Code ( the card's, not the base's )") );
    }
    // resolve with the data that the API wants
    resolve({
      'cc-number': number.replace(/ /g, ''),
      'cc-exp': expiry.replace(/ |\//g, ''),
      'x_card_code': cvc,
      'zip': zip.trim()
    });
  });
}


// WEBPACK FOOTER //
// ./src/functions/validations.js